import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react'
import "./styles.scss";

export default class SearchFieldGE extends Component {
  state = {
    val: ''
  };
  inputRef = React.createRef(null);

  handleChange = (event) => {
    let {
      onChange = () => {
        //Default value for onChange
      },
      re = /^[a-zA-Z0-9- ]*$/
    } = this.props;
    let value = event.target && event.target.value;
    if (value === '' || re.test(value)) {
      this.setState({ val: value });
      onChange(value);
    }
  }

  clearValue = () => {
    let { onClear = () => {
      //Default value for onClear
    } } = this.props;
    let value = '';
    this.setState({ val: value });
    onClear(value);
  }

  render() {
    const { placeholder = 'Enter Text...', className = "", value } = this.props;
    
    return (
      <div className="input-wrapper-ge">
       <input ref={this.inputRef} type="text" placeholder={placeholder} onChange={this.handleChange} className={className} value={value} />
        {
          this.props.value !== "" &&
          <span className="close-icon-search-bar">
            <FontAwesomeIcon icon="times-circle" onClick={this.clearValue} />
          </span>
        }
        <FontAwesomeIcon icon="search" onClick={this.handleSearch} />
      </div>
    )
  }
}
